/*  
* EXPORT ARRAY: Predefined profiles for the sidemenu
* Content of File:
* - scientistMenu
* - doctorMenu
* - patientMenu
* - allPages
*/

// ARRAY: Predefined profile for the user "Employee".
export let employeeMenu = [
  {
    title: 'Home',
    url: '/home',
    icon: 'home'
  },
  {
    title: 'Phonebook',
    url: '/phonebook',
    icon: 'call'
  },
  {
    title: 'Food & Catering',
    icon: 'restaurant',
    subPages: [
      {
        title: 'Oase',
        url: '/oasemenu',
        icon: '',
        display: true
      },
      {
        title: 'PIA Culinaare',
        url: '/pia-culinaare',
        icon: '',
        display: true
      },
      {
        title: 'Foodmarket',
        url: '/foodmarket',
        icon: '',
        display: true
      }
    ]
  },
  {
    title: 'Public Transport',
    url: '/publictransport',
    icon: 'bus'
  },
  {
    title: 'PSI Map',
    url: '/psimap',
    icon: 'map'
  },
  {
    title: 'Recycling',
    url: '/recycling',
    icon: 'leaf'
  }

  ];

// ARRAY: Predefined profile for the user "Scientist".
export let scientistMenu = [
  {
    title: 'Home',
    url: '/home',
    icon: 'home'
  },
  {
    title: 'Status Accelerators',
    icon: 'stats-chart',
    subPages: [
      {
        title: 'SLS',
        url: '/slsstatus',
        icon: '',
        display: true
      },
      {
        title: 'Proton Accelerator',
        url: '/hipastatus',
        icon: '',
        display: true
      },
      {
        title: 'SwissFEL',
        url: '/swissfelstatus',
        icon: '',
        display: true
      },
      {
        title: 'PROSCAN',
        url: '/proscanstatus',
        icon: '',
        display: true
      }
    ]
  },
  {
    title: 'Phonebook',
    url: '/phonebook',
    icon: 'call'
  },
  {
    title: 'Food & Catering',
    icon: 'restaurant',
    subPages: [
      {
        title: 'Oase',
        url: '/oasemenu',
        icon: '',
        display: true
      },
      {
        title: 'PIA Culinaare',
        url: '/pia-culinaare',
        icon: '',
        display: true
      },
      {
        title: 'Foodmarket',
        url: '/foodmarket',
        icon: '',
        display: true
      }
    ]
  },
  {
    title: 'Public Transport',
    url: '/publictransport',
    icon: 'bus'
  },
  {
    title: 'PSI Map',
    url: '/psimap',
    icon: 'map'
  },
  {

    title: 'Recycling',
    url: '/recycling',
    icon: 'leaf'
  },
  {

    title: 'Scientific Highlights',
    url: '/scientific-highlights',
    icon: 'newspaper'
  },
];

// ARRAY: Predefined profile for the user "CPT Patient".
export let patientMenu = [
  {
    title: 'Home',
    url: '/home',
    icon: 'home'
  },
  {
    title: 'Proton Therapy Contacts',
    url: '/cpt-contacts',
    icon: 'medical'
  },
  {
    title: 'Food & Catering',
    icon: 'restaurant',
    subPages: [
      {
        title: 'Oase',
        url: '/oasemenu',
        icon: '',
        display: true
      },
      {
        title: 'PIA Culinaare',
        url: '/pia-culinaare',
        icon: '',
        display: true
      },
      {
        title: 'Foodmarket',
        url: '/foodmarket',
        icon: '',
        display: true
      }
    ]
  },
  {
    title: 'Public Transport',
    url: '/publictransport',
    icon: 'bus'
  },
  {
    title: 'PSI Map',
    url: '/psimap',
    icon: 'map'
  },

  {
    title: 'Recycling',
    url: '/recycling',
    icon: 'leaf'
  }

];

// ARRAY: Array with all pages of the PSI for comparison purposes.
export let allPages = [
  {
    title: 'Home',
    url: '/home',
    icon: 'home'
  },
  {
    title: 'Status Accelerators',
    icon: 'stats-chart',
    subPages: [
      {
        title: 'SLS',
        url: '/slsstatus',
        icon: '',
        display: true
      },
      {
        title: 'Proton Accelerator',
        url: '/hipastatus',
        icon: '',
        display: true
      },
      {
        title: 'SwissFEL',
        url: '/swissfelstatus',
        icon: '',
        display: true
      },
      {
        title: 'PROSCAN',
        url: '/proscanstatus',
        icon: '',
        display: true
      }
    ]
  },
  {
    title: 'Phonebook',
    url: '/phonebook',
    icon: 'call'
  },
  {
    title: 'Food & Catering',
    icon: 'restaurant',
    subPages: [
      {
        title: 'Oase',
        url: '/oasemenu',
        icon: '',
        display: true
      },
      {
        title: 'PIA Culinaare',
        url: '/pia-culinaare',
        icon: '',
        display: true
      },
      {
        title: 'Foodmarket',
        url: '/foodmarket',
        icon: '',
        display: true
      }
    ]
  },
  {
    title: 'Public Transport',
    url: '/publictransport',
    icon: 'bus'
  },
  {
    title: 'PSI Map',
    url: '/psimap',
    icon: 'map'
  },
  {
    title: 'Recycling',
    url: '/recycling',
    icon: 'leaf'
  },
  {
    title: 'Scientific Highlights',
    url: '/scientific-highlights',
    icon: 'newspaper'
  },
  {
    title: 'Proton Therapy Contacts',
    url: '/cpt-contacts',
    icon: 'medical'
  }
];
